import { MESSAGES } from "../organizations.constants";

const EmptyState = () => (
  <div className="bg-gray-100 border border-gray-300 text-gray-700 px-4 py-8 rounded text-center">
    {MESSAGES.EMPTY}
  </div>
);

export default EmptyState;
